// extracted by mini-css-extract-plugin
export var header = "_uo-1";
export var maskBottom = "_uo-6";
export var maskMiddle = "_uo-7";
export var maskTop = "_uo-5";
export var root = "_uo-0";
export var scrollDownButton = "_uo-3";
export var scrollDownButtonHidden = "_uo-4";
export var viewport = "_uo-2";